/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { TaskBackUpResponse } from '../model/taskBackUpResponse';
// @ts-ignore
import { TaskBackupSpec } from '../model/taskBackupSpec';
// @ts-ignore
import { TaskCancelSpec } from '../model/taskCancelSpec';
// @ts-ignore
import { TaskConfigResponse } from '../model/taskConfigResponse';
// @ts-ignore
import { TaskConfigSpec } from '../model/taskConfigSpec';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';
// @ts-ignore
import { TasksBackUpPaginatedResponse } from '../model/tasksBackUpPaginatedResponse';
// @ts-ignore
import { TasksPaginatedResponse } from '../model/tasksPaginatedResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class TasksOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Copy/Move/Delete/Restore tasks to/from backup
     * Copy/Move/Delete/Restore set of tasks to/from backup tasks table based on provided filter parameters. Use dry_run&#x3D;true to preview the operation without making changes.
     * @param taskBackupSpec Task spec for backup operation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public backupTasksOperator(taskBackupSpec: TaskBackupSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskBackUpResponse>;
    public backupTasksOperator(taskBackupSpec: TaskBackupSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskBackUpResponse>>;
    public backupTasksOperator(taskBackupSpec: TaskBackupSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskBackUpResponse>>;
    public backupTasksOperator(taskBackupSpec: TaskBackupSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskBackupSpec === null || taskBackupSpec === undefined) {
            throw new Error('Required parameter taskBackupSpec was null or undefined when calling backupTasksOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/backUp`;
        return this.httpClient.request<TaskBackUpResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskBackupSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cancel a specific Task
     * Cancel a specific Task
     * @param taskId Task identifier
     * @param taskCancelSpec Specification for task cancellation
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelTaskOperator(taskId: string, taskCancelSpec: TaskCancelSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public cancelTaskOperator(taskId: string, taskCancelSpec: TaskCancelSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public cancelTaskOperator(taskId: string, taskCancelSpec: TaskCancelSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public cancelTaskOperator(taskId: string, taskCancelSpec: TaskCancelSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling cancelTaskOperator.');
        }
        if (taskCancelSpec === null || taskCancelSpec === undefined) {
            throw new Error('Required parameter taskCancelSpec was null or undefined when calling cancelTaskOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/cancel`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskCancelSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Task info for a specific Task
     * Get Task info for a specific Task
     * @param taskId Task identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaskV2Operator(taskId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public getTaskV2Operator(taskId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public getTaskV2Operator(taskId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public getTaskV2Operator(taskId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskId === null || taskId === undefined) {
            throw new Error('Required parameter taskId was null or undefined when calling getTaskV2Operator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/${this.configuration.encodeParam({name: "taskId", value: taskId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/v2`;
        return this.httpClient.request<TaskV2>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all Task Info from Backup DB
     * Get all Task info from Backup DB
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the tasks by this column
     * @param orgId ORG identifier
     * @param serviceType Service Type
     * @param taskState 
     * @param vcdsServiceType VCDS Service Type
     * @param resourceType Task Resource Type
     * @param taskType Task Type
     * @param taskSubType Task Sub Type
     * @param createdBy task created by
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTasksBackupOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TasksBackUpPaginatedResponse>;
    public getTasksBackupOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TasksBackUpPaginatedResponse>>;
    public getTasksBackupOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TasksBackUpPaginatedResponse>>;
    public getTasksBackupOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getTasksBackupOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getTasksBackupOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        if (taskState) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...taskState].join(COLLECTION_FORMATS['csv']), 'task-state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourceType, 'resource-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskType, 'task-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskSubType, 'task-sub-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/backUp`;
        return this.httpClient.request<TasksBackUpPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get task configuration
     * Get task configuration
     * @param configType Config type for event/tasks
     * @param configSubType Config sub type for event/tasks
     * @param showOnTenantUi Flag to indicate if task/event to be shown to tenant
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTasksConfigOperator(configType?: string, configSubType?: string, showOnTenantUi?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<Array<TaskConfigResponse>>;
    public getTasksConfigOperator(configType?: string, configSubType?: string, showOnTenantUi?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TaskConfigResponse>>>;
    public getTasksConfigOperator(configType?: string, configSubType?: string, showOnTenantUi?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TaskConfigResponse>>>;
    public getTasksConfigOperator(configType?: string, configSubType?: string, showOnTenantUi?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configType, 'config-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configSubType, 'config-sub-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>showOnTenantUi, 'show-on-tenant-ui');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/task-config`;
        return this.httpClient.request<Array<TaskConfigResponse>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all Task Info
     * Get all Task info
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the tasks by this column
     * @param orgId ORG identifier
     * @param orgName ORG name
     * @param orgType Org Type
     * @param taskId Task identifier sub string
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param taskState 
     * @param resourceType Task Resource Type
     * @param taskType Task Type
     * @param taskSubType Task Sub Type
     * @param createdBy task created by
     * @param from Time at which task was created
     * @param to Time at which task was closed
     * @param paginate Paginate the records
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTasksV2Operator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, orgName?: string, orgType?: string, taskId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TasksPaginatedResponse>;
    public getTasksV2Operator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, orgName?: string, orgType?: string, taskId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TasksPaginatedResponse>>;
    public getTasksV2Operator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, orgName?: string, orgType?: string, taskId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TasksPaginatedResponse>>;
    public getTasksV2Operator(sortByOrder: 'ASC' | 'DESC', sortBy: 'orgId' | 'orgName' | 'orgType' | 'serviceType' | 'vcdsServiceType' | 'state' | 'resourceType' | 'taskType' | 'taskSubType' | 'startTime' | 'endTime' | 'createdBy' | 'progressPercent', orgId?: string, orgName?: string, orgType?: string, taskId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VCDS', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', taskState?: Array<'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED'>, resourceType?: 'NONE' | 'DEPLOYMENT' | 'AWS_ACCOUNT' | 'REQUEST_ACCESS' | 'SUBSCRIPTION' | 'RELEASE' | 'RANSOMWARE_RECOVERY_DEPLOYMENT' | 'VMCFS_DEPLOYMENT' | 'SEED_OAUTH_APP' | 'MAINTENANCE' | 'DATASTORE' | 'AGENT' | 'AGENT_RECONFIGURE_JOB' | 'VCF_OAUTH_APP' | 'VMC_OAUTH_APP' | 'VMC_POOL' | 'DISCONNECTED_DEPLOYMENT' | 'MONITOR' | 'SDDC' | 'VCF' | 'VMC' | 'VMCA' | 'DRC' | 'SRM_AGENT' | 'ASUP' | 'MULTIPLE_OAUTH_APPS', taskType?: 'DEPLOYMENT' | 'SEED-OAUTH-APP' | 'SUBSCRIPTION' | 'RANSOMWARE-RECOVERY' | 'RELEASE' | 'MAINTENANCE' | 'ACCESS' | 'MIGRATE' | 'RELEASE-CAPABILITY' | 'BILLING-PIPELINE-REFRESH' | 'DATASTORE' | 'CLOUD-PAIRING' | 'VMC-POOL' | 'DISCONNECTED-DEPLOYMENT' | 'RESOURCE-POOL' | 'OAUTH_APP_SECRET_ROTATION', taskSubType?: 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'LINK' | 'UNLINK' | 'ASSIGN_GCVE' | 'ASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_GCVE' | 'UNASSIGN_VMCA' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET' | 'IRR_GW_CERT_UPDATE', createdBy?: string, from?: string, to?: string, paginate?: boolean, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getTasksV2Operator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getTasksV2Operator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgName, 'org-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgType, 'org-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskId, 'task-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        if (taskState) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...taskState].join(COLLECTION_FORMATS['csv']), 'task-state');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>resourceType, 'resource-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskType, 'task-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>taskSubType, 'task-sub-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createdBy, 'created-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>from, 'from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>to, 'to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paginate, 'paginate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/v2`;
        return this.httpClient.request<TasksPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update task configuration
     * Update task configuration
     * @param taskConfigSpec Specification to update an task config
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTaskConfigOperator(taskConfigSpec: TaskConfigSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<TaskConfigResponse>;
    public updateTaskConfigOperator(taskConfigSpec: TaskConfigSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskConfigResponse>>;
    public updateTaskConfigOperator(taskConfigSpec: TaskConfigSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskConfigResponse>>;
    public updateTaskConfigOperator(taskConfigSpec: TaskConfigSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (taskConfigSpec === null || taskConfigSpec === undefined) {
            throw new Error('Required parameter taskConfigSpec was null or undefined when calling updateTaskConfigOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/tasks/task-config`;
        return this.httpClient.request<TaskConfigResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taskConfigSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
